import React, { useEffect, useRef, useState } from 'react'
import styled from 'styled-components'
import ProfileMenu from './ProfileMenu';
import { useAppSelector } from '../../../app/utils/hooks/reduxHook';
import { getImageURL } from '../../../app/utils/common/getImageUrl';
import { image } from '../../../app/utils/common/image';
const ProfileSectionContainer = styled.div`
display:flex;
flex-direction:row;
align-items:center;
justify-content:center;
margin-left:28px;
position:relative;
transition: all 0.7s ease-in-out;
`;

const ProfilePicture = styled.img`
height:45px;
width:45px;
border: 2px solid #FFFFFF;
border-radius:50%;
box-shadow: 0px 4px 4px 0px #00000040;

`;
const ProfileName = styled.p`
color: #171717;
font-family: Urbanist, sans-serif;
font-size: 20px;
font-weight: 600;
line-height: 24px;
text-align: left;
margin-left:13px;
`;
const DownIconComp = styled.img`

`;
const UpIconComp = styled.img`
transform:rotate(180deg);
`;

const DownIconContainer = styled.div`
margin-left:18px;
cursor:pointer;
`;
const ProfileSection: React.FC = () => {
    const { user } = useAppSelector(state => state.auth);
    const [menuOpen, setMenuOpen] = useState(false);


    return (
        <ProfileSectionContainer>
            {menuOpen && <ProfileMenu setMenuOpen={setMenuOpen} menuOpen={menuOpen} />}
            {(user && user.profile_image) ? <ProfilePicture src={getImageURL(user.profile_image)} /> : <ProfilePicture src={image.DEFAULT_PROFILE_IMAGE} />}

            <ProfileName >{user ? user.name : 'ARB Venture'}</ProfileName>
            <DownIconContainer onClick={() => { setMenuOpen(pre => !pre) }}>
                {
                    menuOpen ?
                        <UpIconComp src={image.PROFILE_DOWN_ICON} height={10} width={20} />
                        :
                        <DownIconComp src={image.PROFILE_DOWN_ICON} height={10} width={20} />
                }
            </DownIconContainer>

        </ProfileSectionContainer>
    )
}

export default ProfileSection